import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";

export default function CategoryQuickEntry() {
  return (
    <section className="px-4 pt-10 md:px-6 md:pt-14">
      <div className="mb-5 flex items-end justify-between">
        <div>
          <h2 className="font-heading text-xl font-extrabold text-foreground-950 md:text-2xl">
            分类速览
          </h2>
          <p className="mt-1 text-sm text-foreground-500">
            按兴趣快速进入你喜欢的短视频频道
          </p>
        </div>
      </div>
      <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-5 md:gap-4">
        {categories.map((c) => (
          <Link
            key={c.slug}
            to={`/category/${c.slug}`}
            className="group flex flex-col items-start gap-3 rounded-lg border border-background-200 bg-background-100 p-4 transition-colors duration-200 hover:border-primary-300 md:p-5"
          >
            <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-primary-100 text-primary-600 transition-colors duration-200 group-hover:bg-primary-500 group-hover:text-background-50">
              <i className={`${c.icon} text-2xl`}></i>
            </span>
            <span className="font-heading text-base font-bold text-foreground-950">
              {c.name}
            </span>
            <span className="text-xs leading-relaxed text-foreground-500 line-clamp-2">
              {c.desc}
            </span>
          </Link>
        ))}
      </div>
    </section>
  );
}